import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { inject, injectable } from 'tsyringe';
import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api';
import { createElement } from '@gn-audio/core/common/templating';
import { getAuthBearerValue, isSiteFeatureEnabled } from '@gn-audio/core/common/utilities';
import { BasketEventBus } from '../../services/basket-event-bus.service';
import { SFCCTokenService } from '../../services/sfcc-token.service';
import { getBasketTotalCount } from '../../utilities/get-basket-total-count';
import './basket-checkout.component.scss';
import template from './basket-checkout.component.html';
var BasketCheckoutComponent = /** @class */ (function () {
    function BasketCheckoutComponent(eventBus, tokenService, translations, settings) {
        var _this = this;
        this.eventBus = eventBus;
        this.tokenService = tokenService;
        this.translations = translations;
        this.settings = settings;
        this.onCheckout = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var isTopMenuUipEnabled, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        return [4 /*yield*/, isSiteFeatureEnabled("TopMenuUipEnabled" /* SiteFeature.TopMenuUipEnabled */)];
                    case 1:
                        isTopMenuUipEnabled = _a.sent();
                        if (!isTopMenuUipEnabled) {
                            //TopMenuUipEnabled feature is disabled meaning that we should not show auth choices
                            this.submit();
                            return [2 /*return*/];
                        }
                        client = getWebStoreApiClient();
                        if (client.account) {
                            this.submit();
                        }
                        else {
                            this.eventBus.post("show-authorization-options" /* BasketEvent.ShowAuthorizationOptions */);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        this.reactOnStoreChanges = function (state) {
            var totalCount = getBasketTotalCount(state);
            if (totalCount === 0) {
                _this.rootElement.classList.remove("visible" /* CssClass.Visible */);
                _this.buttonElement.setAttribute('disabled', 'disabled');
            }
            else {
                _this.rootElement.classList.add("visible" /* CssClass.Visible */);
                _this.buttonElement.removeAttribute('disabled');
            }
        };
    }
    BasketCheckoutComponent.prototype.register = function (state) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.attachEvents();
                        return [4 /*yield*/, this.attachToTargetElement()];
                    case 1:
                        _a.sent();
                        this.reactOnStoreChanges(state);
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketCheckoutComponent.prototype.attachEvents = function () {
        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnStoreChanges);
    };
    BasketCheckoutComponent.prototype.attachToTargetElement = function () {
        return __awaiter(this, void 0, void 0, function () {
            var targetElement;
            return __generator(this, function (_a) {
                targetElement = document.querySelector(".basket-ui__footer" /* BasketUIElementSelector.BasketFooter */);
                if (!targetElement) {
                    console.warn("Basket checkout was not able to attach to target element: ".concat(".basket-ui__footer" /* BasketUIElementSelector.BasketFooter */));
                    return [2 /*return*/];
                }
                this.rootElement = createElement(template, { actionUrl: this.settings.basketCheckoutUrl }, this.translations);
                targetElement.insertAdjacentElement('beforeend', this.rootElement);
                this.rootElement.addEventListener('submit', this.onCheckout);
                this.buttonElement = this.rootElement.querySelector('.basket-checkout__button');
                this.tokenHiddenInput = this.rootElement.querySelector('input[name="token"]');
                return [2 /*return*/];
            });
        });
    };
    BasketCheckoutComponent.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.tokenHiddenInput;
                        _b = getAuthBearerValue;
                        return [4 /*yield*/, this.tokenService.ensure()];
                    case 1:
                        _a.value = _b.apply(void 0, [_c.sent()]);
                        this.rootElement.submit();
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketCheckoutComponent = __decorate([
        injectable(),
        __param(2, inject("basketTranslations" /* DiToken.Translations */)),
        __param(3, inject("basketSettings" /* DiToken.Settings */)),
        __metadata("design:paramtypes", [BasketEventBus,
            SFCCTokenService, Object, Object])
    ], BasketCheckoutComponent);
    return BasketCheckoutComponent;
}());
export { BasketCheckoutComponent };
